/**
 * Reservation types both for daily/hourly
 */

export enum ReservableStatusType {
  UNAPPROVED = 'unapproved',
  APPROVED = 'approved',
  CANCELLED = 'cancelled',
  WAITING_FOR_PAYMENT = 'waiting_for_payment'
}
